const NEW_PROFILE_DAYS = 30;

// There are exactly four dynamic profile meta templates.
const PROFILE_META_TEMPLATES = {
  qualityMark: {
    title: "{name} - Quality Mark {categoryTitle} Escort Dubai | Top-Rated",
    description:
      "Meet {name}: Quality Mark certified escort in Dubai. Top-rated, verified & trusted - the highest standard on EmiratEscort. View photos & book.",
  },
  verified: {
    title:
      "{name} - \u2713 Verified {categoryTitle} Escort in Dubai | Emirates",
    description:
      "Meet {name}: verified {categoryDescriptionPhrase} in Dubai. 100% real photos, authentic profile. Discreet & available now - view profile & contact.",
  },
  new: {
    title:
      "{name} - New {categoryTitle} Escort in Dubai | Just Joined Emirates",
    description:
      "New on EmiratEscort: meet {name}, {categoryDescriptionPhrase} in Dubai. Fresh profile - real photos & available now. View profile & get in touch today.",
  },
  regular: {
    title: "{name} - {categoryTitle} Escort in Dubai | EmiratEscort",
    description:
      "Meet {name}: {categoryDescriptionPhrase} in Dubai. View photos, rates & full profile - discreet & available. Browse and contact today.",
  },
};

// Status priority: Quality Mark -> Verified -> New -> Regular.
function getProfileMetaTemplateKey(profile) {
  if (hasProfileStatus(profile, "quality mark") || isTruthyFlag(profile?.qm)) {
    return "qualityMark";
  }

  if (hasProfileStatus(profile, "verified") || Boolean(profile?.verified_at)) {
    return "verified";
  }

  if (isNewProfile(profile)) {
    return "new";
  }

  return "regular";
}

// Category choice priority:
// 1. selected services from serviceDetails[0].service
// 2. profile gender fallback
// TODO: confirm the priority when several service categories are selected.
const SERVICE_CATEGORY_RULES = [
  {
    serviceKeys: [
      "massage",
      "Erotic massage",
      "nuru-massage",
      "Body-to-Body massage",
      "tantric-massage",
    ],
    title: "Massage",
    description: "massage escort",
  },
  {
    serviceKeys: ["BDSM - Femdom", "mistress", "domination"],
    genders: ["female"],
    title: "Mistress",
    description: "mistress",
  },
];

const CATEGORY_BY_GENDER = {
  female: {
    title: "Female",
    description: "female",
  },
  male: {
    title: "Male",
    description: "male",
  },
  transgender: {
    title: "Shemale & TS",
    description: "shemale & TS",
  },
};

function getProfileMetaCategory(profile) {
  const serviceCategory = getCategoryFromSelectedServices(profile);
  if (serviceCategory) return serviceCategory;

  const gender = getProfileGender(profile);

  return (
    CATEGORY_BY_GENDER[gender] || {
      title: normalizeText(profile?.gender) || "Female",
      description: (normalizeText(profile?.gender) || "female").toLowerCase(),
    }
  );
}

function getCategoryFromSelectedServices(profile) {
  const services = profile?.serviceDetails?.[0]?.service;
  if (!services || typeof services !== "object" || Array.isArray(services)) {
    return null;
  }

  const selectedServiceKeys = Object.keys(services).filter((key) =>
    isSelectedService(services[key])
  );

  const gender = getProfileGender(profile);

  for (const rule of SERVICE_CATEGORY_RULES) {
    if (
      isRuleAllowedForGender(rule, gender) &&
      rule.serviceKeys.some((key) => selectedServiceKeys.includes(key))
    ) {
      return {
        title: rule.title,
        description: rule.description,
      };
    }
  }

  return null;
}

function getProfileGender(profile) {
  return String(profile?.gender || profile?.myDetails?.[0]?.gender || "")
    .trim()
    .toLowerCase();
}

function isRuleAllowedForGender(rule, gender) {
  return !rule.genders || rule.genders.includes(gender);
}

export function generateProfileDynamicMeta(profile) {
  const templateKey = getProfileMetaTemplateKey(profile);
  const template = PROFILE_META_TEMPLATES[templateKey];
  const category = getProfileMetaCategory(profile);
  const values = {
    name: normalizeText(profile?.name),
    categoryTitle: category.title,
    categoryDescriptionPhrase: getEscortPhrase(category.description),
  };

  return {
    templateKey,
    title: fillTemplate(template.title, values),
    description: fillTemplate(template.description, values),
  };
}

function hasProfileStatus(profile, status) {
  if (!Array.isArray(profile?.profileStatus)) return false;
  const targetStatus = status.toLowerCase();

  return profile.profileStatus.some(
    (item) => String(item).trim().toLowerCase() === targetStatus
  );
}

function isTruthyFlag(value) {
  return value === true || value === 1 || value === "1" || value === "true";
}

function isSelectedService(value) {
  return (
    value !== null && value !== undefined && value !== false && value !== ""
  );
}

function getEscortPhrase(categoryDescription) {
  const description = normalizeText(categoryDescription);
  if (!description) return "escort";
  if (description.toLowerCase().includes("escort")) return description;
  return `${description} escort`;
}

function isNewProfile(profile, now = new Date()) {
  // TODO: confirm with SEO/backend whether activated_at should be used instead.
  const createdAt = parseProfileDate(profile?.created_at);
  if (!createdAt) return false;

  const ageMs = now.getTime() - createdAt.getTime();
  const newProfileMs = NEW_PROFILE_DAYS * 24 * 60 * 60 * 1000;

  return ageMs >= 0 && ageMs <= newProfileMs;
}

function parseProfileDate(value) {
  if (!value) return null;
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;

  const [, year, month, day] = match;
  return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
}

function fillTemplate(template, values) {
  return template.replace(/\{(\w+)\}/g, (match, key) => values[key] || "");
}

function normalizeText(value) {
  return String(value || "").trim();
}
